export default [
	{
		path: '/jointManage/list',
		name: 'JointManageList',
		component: () => import('@/views/joint-manage/list.vue'),
		meta: { title: '绑定家属' }
	},
	{
		path: '/jointManage/invite/:id',
		name: 'JointManageInvite',
		component: () => import('@/views/joint-manage/invite.vue'),
		meta: { title: '绑定家属' }
	},
	{
		path: '/jointManage/apply/:id',
		name: 'JointManageApply',
		component: () => import('@/views/joint-manage/apply.vue'),
		meta: { title: '绑定家属' }
	},
	{
		path: '/jointManage/result/:id',
		name: 'JointManageResult',
		component: () => import('@/views/joint-manage/result.vue'),
		meta: { title: '卒中平台' }
	}
]
